import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cda7064c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column align-start ga-2 mb-2" }
const _hoisted_2 = { class: "text-subtitle-1" }
const _hoisted_3 = { class: "d-flex align-center ga-2" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-center ga-2"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle-2 mb-2" }, "Rondas", -1))
const _hoisted_6 = { class: "d-flex flex-wrap ga-2 mb-3" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle-2 mb-2" }, "Podio", -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-subtitle-2 mb-2" }, "Podio Individual", -1))
const _hoisted_11 = { class: "text-subtitle-2 mb-2" }
const _hoisted_12 = {
  key: 1,
  class: "d-flex align-center ga-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-body-2 text-medium-emphasis" }, "Cargando clasificación...", -1))
const _hoisted_14 = {
  key: 3,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_15 = {
  key: 0,
  style: {"margin-top":"10px","text-align":"center","font-size":"12px"}
}

import { computed, ref } from "vue";
import { ListaCompletaDTO } from "@/interfaces/Lista";
import { getListasTorneoAsync } from "@/services/TorneosService";
import { ResumenTorneoDTO } from "@/interfaces/Torneo";
import { descargarListasPDF } from "@/utils/descargarListas";
import LoadingLOTR from "@/components/Commons/LoadingLOTR.vue";
import ModalError from "@/components/Commons/ModalError.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'TabResumenTorneo',
  props: {
    resumen: {},
    isLoadingPartidas: { type: Boolean },
    tipoTorneo: {},
    podioEquipos: {},
    idTorneo: {},
    nombreTorneo: {}
  },
  emits: ["go-listas", "go-clasificacion", "go-ronda"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isDownloading = ref(false);
const progressPDF = ref(0);
const showErrorModal = ref(false);

const isTeamTournament = computed(() =>
  ["Parejas", "Equipos_2", "Equipos_4", "Equipos_6"].includes(props.tipoTorneo ?? "")
);

function medalIcon(index: number): string {
  if (index === 0) return "mdi-medal";
  if (index === 1) return "mdi-medal";
  return "mdi-medal";
}

function medalColor(index: number): string {
  if (index === 0) return "#FFD700";
  if (index === 1) return "#C0C0C0";
  return "#CD7F32";
}

function formatFecha(fecha: string): string {
  const [year, month, day] = fecha.split("-");
  return `${day}/${month}/${year}`;
}

const descargarListas = async () => {
  try {
    isDownloading.value = true;
    const response = await getListasTorneoAsync(props.idTorneo);
    const listas: ListaCompletaDTO[] = response.data;
    await descargarListasPDF(
      listas,
      props.nombreTorneo ?? "",
      undefined,
      (current, total) => { progressPDF.value = Math.round((current / total) * 100); }
    );
  } catch (error) {
    console.error("Error descargando las listas:", error);
    showErrorModal.value = true;
  } finally {
    isDownloading.value = false;
    progressPDF.value = 0;
    showErrorModal.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_card, {
      flat: "",
      class: "pa-4"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, "Fecha del torneo: " + _toDisplayString(formatFecha(_ctx.resumen.fecha)), 1),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_chip, {
              size: "small",
              color: _ctx.resumen.listasVisibles ? 'primary' : 'default',
              style: _normalizeStyle(_ctx.resumen.listasVisibles ? 'cursor:pointer' : ''),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.resumen.listasVisibles && emit('go-listas')))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Listas " + _toDisplayString(_ctx.resumen.listasVisibles ? 'visibles' : 'ocultas'), 1)
              ]),
              _: 1
            }, 8, ["color", "style"]),
            (_ctx.resumen.listasVisibles)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_v_btn, {
                    icon: "",
                    size: "x-small",
                    variant: "text",
                    color: "primary",
                    loading: isDownloading.value,
                    disabled: isDownloading.value,
                    onClick: descargarListas
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => [
                          _createTextVNode("mdi-download")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "disabled"])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_v_chip, {
            size: "small",
            color: _ctx.isLoadingPartidas ? 'grey' : (_ctx.resumen.clasificacionVisible ? 'primary' : 'default'),
            "prepend-icon": _ctx.isLoadingPartidas ? 'mdi-loading' : undefined,
            style: _normalizeStyle(!_ctx.isLoadingPartidas && _ctx.resumen.clasificacionVisible ? 'cursor:pointer' : ''),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (!_ctx.isLoadingPartidas && _ctx.resumen.clasificacionVisible && emit('go-clasificacion')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Clasificación " + _toDisplayString(_ctx.isLoadingPartidas ? '...' : (_ctx.resumen.clasificacionVisible ? 'visible' : 'oculta')), 1)
            ]),
            _: 1
          }, 8, ["color", "prepend-icon", "style"])
        ]),
        _createVNode(_component_v_divider, { class: "mb-3" }),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resumen.rondas, (generada, i) => {
            return (_openBlock(), _createBlock(_component_v_chip, {
              key: i,
              color: _ctx.isLoadingPartidas ? 'grey' : (generada ? 'primary' : 'grey'),
              "prepend-icon": _ctx.isLoadingPartidas ? 'mdi-loading' : (generada ? 'mdi-check-circle' : 'mdi-clock-outline'),
              style: _normalizeStyle(!_ctx.isLoadingPartidas && generada ? 'cursor:pointer' : ''),
              variant: "tonal",
              onClick: ($event: any) => (!_ctx.isLoadingPartidas && generada && emit('go-ronda', i + 1))
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Ronda " + _toDisplayString(i + 1), 1)
              ]),
              _: 2
            }, 1032, ["color", "prepend-icon", "style", "onClick"]))
          }), 128))
        ]),
        (_ctx.resumen.clasificacionVisible && !isTeamTournament.value && _ctx.resumen.ganadores.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createVNode(_component_v_divider, { class: "mb-3" }),
              _hoisted_8,
              _createVNode(_component_v_list, { density: "compact" }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resumen.ganadores, (ganador, i) => {
                    return (_openBlock(), _createBlock(_component_v_list_item, {
                      key: i,
                      "prepend-icon": medalIcon(i)
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, {
                          style: _normalizeStyle({ color: medalColor(i) })
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(ganador), 1)
                          ]),
                          _: 2
                        }, 1032, ["style"])
                      ]),
                      _: 2
                    }, 1032, ["prepend-icon"]))
                  }), 128))
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (_ctx.resumen.clasificacionVisible && isTeamTournament.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.resumen.ganadores.length > 0 && _ctx.tipoTorneo !== 'Parejas')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createVNode(_component_v_divider, { class: "mb-3" }),
                    _hoisted_10,
                    _createVNode(_component_v_list, { density: "compact" }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resumen.ganadores, (ganador, i) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: i,
                            "prepend-icon": medalIcon(i)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                style: _normalizeStyle({ color: medalColor(i) })
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(ganador), 1)
                                ]),
                                _: 2
                              }, 1032, ["style"])
                            ]),
                            _: 2
                          }, 1032, ["prepend-icon"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_divider, { class: "mb-3 mt-2" }),
              _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.tipoTorneo === "Parejas" ? "Podio Parejas" : "Podio Equipos"), 1),
              (_ctx.isLoadingPartidas)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createVNode(_component_v_progress_circular, {
                      indeterminate: "",
                      color: "primary",
                      size: "20",
                      width: "2"
                    }),
                    _hoisted_13
                  ]))
                : (_ctx.podioEquipos && _ctx.podioEquipos.length > 0)
                  ? (_openBlock(), _createBlock(_component_v_list, {
                      key: 2,
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.podioEquipos, (equipo, i) => {
                          return (_openBlock(), _createBlock(_component_v_list_item, {
                            key: i,
                            "prepend-icon": medalIcon(i)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_list_item_title, {
                                style: _normalizeStyle({ color: medalColor(i) })
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(equipo), 1)
                                ]),
                                _: 2
                              }, 1032, ["style"])
                            ]),
                            _: 2
                          }, 1032, ["prepend-icon"]))
                        }), 128))
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createElementBlock("p", _hoisted_14, "Sin resultados aún"))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se han podido descargar las listas. Inténtalo de nuevo.",
      "onUpdate:isVisible": _cache[2] || (_cache[2] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(LoadingLOTR, {
      isVisible: isDownloading.value,
      mensaje: "Generando PDF, por favor espera..."
    }, {
      default: _withCtx(() => [
        (isDownloading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(progressPDF.value) + "% ", 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["isVisible"])
  ], 64))
}
}

})